$ ->

    $('[data-count-characters]').each ->
        self = $ @
        area = self.find '.text-container'
        container = self.find '.length-container'

        calc = ->
            container.text area.val().length

        calc()
        area.on 'keyup', calc
